/**
 * Copyright (C) 2018 Adactive SAS
 */

class AbstractOptions{constructor(t={}){this.fromJSON(t)}static resolve(t,s=null){return null===s?t:new this(t).merge(s)}reset(){}merge(t){return Object.keys(t).forEach(s=>{this.hasOwnProperty(s)&&this.set(s,t[s],t)}),this}set(t,s){return this[t]instanceof AbstractOptions?this[t].merge(s):this[t]=s,this}get(t){return this[t]instanceof AbstractOptions?this[t].toJSON():this[t]}fromJSON(t){this.reset(),this.merge(t)}toJSON(){const t={};return Object.keys(this).forEach(s=>{this.hasOwnProperty(s)&&(t[s]=this.get(s))}),t}}export{AbstractOptions};



// WEBPACK FOOTER //
// ./node_modules/@adactive/adactive-abstract-options/build/adactive-abstract-options.module.js